var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAccountIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32.0004 6.85718C25.6886 6.85698 20.5716 11.9736 20.5714 18.2854C20.5712 24.5972 25.6878 29.7141 31.9997 29.7143C38.3115 29.7145 43.4284 24.5979 43.4286 18.2861L43.4286 18.2833C43.421 11.9763 38.3102 6.8652 32.0032 6.85718H32.0004ZM25.1429 18.2855C25.143 14.4989 28.2124 11.4292 31.9989 11.4286C35.7846 11.4342 38.852 14.502 38.8572 18.2877C38.8561 22.074 35.7863 25.143 31.9998 25.1429C28.2127 25.1428 25.1428 22.0726 25.1429 18.2855ZM32 36.5715C40.0605 36.5715 46.7289 42.5319 47.838 50.2858H16.162C17.2711 42.5319 23.9395 36.5715 32 36.5715ZM32 32C20.6387 32 11.4286 41.2102 11.4286 52.5715C11.4286 53.8338 12.4519 54.8572 13.7143 54.8572H50.2857C51.5481 54.8572 52.5714 53.8338 52.5714 52.5715C52.5714 41.2102 43.3613 32 32 32Z",
    fill: "#00013A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccountIcon);
export default __webpack_public_path__ + "static/media/account-icon.8c4a971c992e51284f9a023be99e88bf.svg";
export { ForwardRef as ReactComponent };